import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FeatureTypeDto, RegisteredApplicationDto } from '../../api/NSwagApi/api';

interface State {
	registeredApplications: RegisteredApplicationDto[];
	selectedApplication:string;
	refreshApplications: boolean;
	featureTypes: FeatureTypeDto[];
}

const initialState: State = {
	registeredApplications: [],
	selectedApplication: '',
	refreshApplications: true,
	featureTypes: []
};

const applicationsSlice = createSlice({
	initialState,
	name: 'applications',
	reducers: {
		setRegisteredApplications: (
			state,
			action: PayloadAction<RegisteredApplicationDto[] | undefined>
		) => {
			if (action.payload) {
				state.registeredApplications = action.payload;
			}
		},
		setFeatureTypes: (
			state,
			action: PayloadAction<FeatureTypeDto[] | undefined>
		) => {
			if(action.payload) {
				state.featureTypes = action.payload;
			}
		},
		selectedApplication: (
			state,
			action: PayloadAction<string>
		) => {
			state.selectedApplication = action.payload;
		},
		refreshApplications: (
			state,
			action: PayloadAction<boolean>
		) => {
			state.refreshApplications = action.payload;
		},
		applicationsReset: () => initialState
	},
});

export const { setRegisteredApplications, selectedApplication, refreshApplications,setFeatureTypes } = applicationsSlice.actions;
export default applicationsSlice.reducer;